import { getParamsFromNode, sendClick } from '@linecorp/dosi-analytics';
import classNames from 'classnames';
import { useCallback, useRef } from 'react';
import { Button } from 'yoso';
import { t } from '~/components/I18n';
import { Confirm, ConfirmProps, styles } from '~/components/Modal/Confirm/Confirm';

export type LevelUpConfirmPopupProps = ConfirmProps;

export const LevelUpConfirmPopup = ({ onConfirm, ...props }: LevelUpConfirmPopupProps) => {
  const ref = useRef<HTMLButtonElement>(null);

  const onConfirmConfirm = useCallback(
    (e) => {
      onConfirm?.(e);

      if (!ref.current) return;
      const params = getParamsFromNode(ref.current, 'event');
      sendClick('continue_levelup_btn', {
        page_name: params.page_name,
      });
    },
    [onConfirm]
  );
  return (
    <Confirm
      {...props}
      onConfirm={onConfirmConfirm}
      className="level-up-confirm-popup"
      description={t('citizen_membership_levelup_confirm_popup_desc')}
      dismissText={t('citizen_confirm_cancel')}
      // data-event="impression"
      // data-event-category="levelup_confirm_popup"
      // data-event-impression-id="{category}"
      confirmButton={(context) => (
        <Button
          ref={ref}
          className={classNames(styles.button, styles.confirmButton)}
          color="primary"
          onClick={context.confirm}>
          {t('citizen_button_title_continue')}
        </Button>
      )}
    />
  );
};
